import React from "react";
import { compose } from "ramda";
import VerifyTwoFAPage from "./VerifyTwoFAPage";
import VerifyTwoFAPagePP from "./VerifyTwoFAPagePP";
import { sendVerificationEmail, logout } from "../../actions/loginActions";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router";

const VerifyTwoFA = props => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.login.user);
  const twoFAUser = user.hrAdmin || user.employee;
  if (!twoFAUser.twoFAMobile && twoFAUser.email) {
    dispatch(logout());
    dispatch(sendVerificationEmail(twoFAUser.email));
  }
  const isNewUI = useSelector(state => state.common.clientSettings.newUIFlag);
  return isNewUI ? <VerifyTwoFAPagePP {...props} /> : <VerifyTwoFAPage {...props} />;
};

export default compose(withRouter)(VerifyTwoFA);



// WEBPACK FOOTER //
// ./components/twoFA/VerifyTwoFAPageSwitch.js